import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LocationState {
  currentLocation: UserLocation | null;
  status: Status;
}

const initialState: LocationState = {
  currentLocation: null,
  status: ""
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    getLocationSuccess(
      state,
      { payload: { lat, lng } }: PayloadAction<{ lat: number; lng: number }>
    ) {
      state.status = "LOCATED";
      state.currentLocation = { lat, lng };
    },
    noLocationPermission(state, action: PayloadAction) {
      state.status = "NO_LOCATION";
      state.currentLocation = null;
    },
    getLocationFailure(state, { payload }: PayloadAction<Status>) {
      state.status = payload;
      state.currentLocation = null;
    }
  }
});
const { actions, reducer } = locationSlice;
export const {
  noLocationPermission,
  getLocationSuccess,
  getLocationFailure
} = actions;
export { getLocation, getLocationIfEnabled } from "./actions";
export default reducer;
